import { render } from "./PauseIcon.vue?vue&type=template&id=383f840f"
import script from "./PauseIcon.vue?vue&type=script&lang=js"
export * from "./PauseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PauseIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "383f840f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('383f840f', __exports__)) {
    api.reload('383f840f', __exports__)
  }
  
  module.hot.accept("./PauseIcon.vue?vue&type=template&id=383f840f", () => {
    api.rerender('383f840f', render)
  })

}


export default __exports__